<template>
  <v-dialog
    :value="dialog"
    :max-width="400"
    :retain-focus="false"
    @keydown.esc="closeDialog"
    @click:outside="closeDialog"
    @keydown.enter="submit"
  >
    <v-card outlined>
      <v-card-title>
        {{ $t('deleteDialog.title', itemData, itemData) }}
        <p-btn-icon
          type="close"
          btn-class="p-delete-dialog--btn-close"
          @click="closeDialog"
        ></p-btn-icon>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-form ref="form" @submit.stop.prevent>
          <v-container>
            <div v-if="!showRelations" v-html="$t('deleteDialog.textHeader', itemData, itemData)"></div>
            <p-relations v-if="showRelations" :relations-list="relationsList"/>
            <div v-if="serverError" class="red--text darken-3">
              {{ $t('serverError') }}
            </div>
          </v-container>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="justify-end">
        <v-btn text @click="closeDialog">{{ $t('cancel') }}</v-btn>
        <v-btn :disabled="showRelations" text color="primary" @click="submit">{{ $t('delete') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import PBtnIcon from '@/components/PBtnIcon'
import PRelations from '@/components/PRelations'

import dialogMixin from '@/mixins/dialog.mixin'


export default {
  components: {
    PBtnIcon,
    PRelations
  },


  mixins: [
    dialogMixin
  ],


  props: {
    item: {
      type: Object,
      default: () => {}
    },
    itemData: {
      type: Object,
      default: () => {}
    },
    loadRelations: {
      type: Function,
      default: () => {}
    },
    checkRelations: {
      type: Boolean,
      default: true
    },
    deleteItem: {
      type: Function
    }
  },


  data () {
    return {
      relations: null,
      relationsList: null,
      showRelations: false,
      serverError: false
    }
  },


  methods: {
    async getRelations () {
      this.relationsList = []
      this.showRelations = false

      this.relations = await this.loadRelations(this.item.id)

      for (const prop in this.relations) {
        if (Array.isArray(this.relations[prop]) && this.relations[prop].length) {
          this.relationsList.push({
            count: this.relations[prop].length,
            name: prop
          })
        }
      }

      if (this.relationsList.length) {
        this.showRelations = true
      }
    },

    async onDialogOpen () {
      this.serverError = false
      if (this.$refs.form) {
        this.$refs.form.reset()
      }
      if (this.checkRelations) {
        try {
          await this.getRelations()
        } catch (error) {
          this.serverError = true
          this.$log.error(error)
        }
      }
    },

    async submit () {
      try {
        await this.deleteItem(this.item)
        this.$emit('itemDeleted')
        this.closeDialog()
      } catch (error) {
        this.serverError = true
        this.$log.error(error)
      }
    }
  }
}
</script>
